/* eslint-disable no-nested-ternary */
import * as yup from 'yup'
import { useFormik } from 'formik'
import {
  Alert,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
} from '@mui/material'

import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useState } from 'react'
// import useSession from 'src/authentication/hooks/use-session'
import { isNil } from 'ramda'
import DangerousHtml from 'src/v3/components/dangerous-html'
import {
  currentQuizQuestionSteppedForward,
  quizQuestionSelectionAdded,
  selectCurrentQuizQuestion,
  selectCurrentQuizQuestionAtIndex,
  // selectQuiz,
  // selectQuizSessionID,
} from '../live.slice'

type ValidatedQuizAnswer = {
  isCorrect: boolean
  explanation: string
}

export default () => {
  let dispatch = useAppDispatch()
  // let session = useSession()
  let [hasSubmitted, setHasSubmitted] = useState(false)
  let [submitting, setSubmitting] = useState(false)
  let [validatedAnswer, setValidatedAnswer] = useState<
    ValidatedQuizAnswer | undefined
  >()
  let currentQuestionIndex = useAppSelector(selectCurrentQuizQuestion)
  let question = useAppSelector(
    selectCurrentQuizQuestionAtIndex(currentQuestionIndex),
  )
  // let quiz = useAppSelector(selectQuiz)
  // let sessionID = useAppSelector(selectQuizSessionID)

  let form = useFormik({
    validationSchema: yup.object({
      answer: yup.string().required(),
    }),
    initialValues: {
      answer: '',
    },
    onSubmit: async (values) => {
      setHasSubmitted(true)
      setSubmitting(true)
      let validatedQuizAnswer = await axios
        .get<ValidatedQuizAnswer>(
          `/api/v2/live-class/answer/validate?id=${values.answer}`,
        )
        .then(({ data }) => data)
      setSubmitting(false)

      // await axios.post('/api/v2/classroom/quiz/event', {
      //   QuestionEvent: {
      //     sessionId: sessionID,
      //     userId: session?.userId,
      //     quizId: quiz.id,
      //     status: validatedQuizAnswer.isCorrect ? 'passed' : 'failed',
      //     questionId: question.id,
      //     choiceId: values.answer,
      //   },
      // })
      setValidatedAnswer(validatedQuizAnswer)
    },
  })

  return (
    <div className="w-full">
      <Paper className="w-full p-4 mx-auto my-4">
        <form
          onSubmit={form.handleSubmit}
          className="flex flex-col"
          style={{ fontSize: '1.25rem' }}
        >
          <DangerousHtml htmlVal={question?.text} />
          {question?.figureImageName && (
            <img
              src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${question?.figureImageName}`}
              width="100%"
              className="my-3"
            />
          )}
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="answer"
              name="answer"
              value={form.values.answer}
              onChange={form.handleChange}
            >
              {question?.choices?.map((c: any) => (
                <FormControlLabel
                  disabled={hasSubmitted}
                  value={c.id}
                  control={<Radio color="primary" />}
                  label={c.text}
                />
              ))}
            </RadioGroup>
          </FormControl>
          <div>
            {validatedAnswer?.isCorrect === true ? (
              <Alert variant="outlined" severity="success">
                {validatedAnswer?.explanation}
              </Alert>
            ) : validatedAnswer?.isCorrect === false ? (
              <Alert variant="outlined" severity="error">
                {validatedAnswer?.explanation}
              </Alert>
            ) : (
              <> </>
            )}
          </div>
          <div className="flex flex-row-reverse mt-4">
            {!isNil(validatedAnswer) ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(
                    quizQuestionSelectionAdded({
                      answerId: form.values.answer,
                      questionId: question?.id,
                    }),
                  )
                  dispatch(currentQuizQuestionSteppedForward())
                  setValidatedAnswer(undefined)
                  setHasSubmitted(false)
                }}
              >
                Next Question
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={submitting}
              >
                {submitting ? <CircularProgress size="20px" /> : 'Submit'}
              </Button>
            )}
          </div>
        </form>
      </Paper>
    </div>
  )
}
